module.exports = __webpack_public_path__ + "img/FCHS_ER_2023-7.469a618b.jpg";